export const Endpoint = {
  LOGIN: "login",
  REFRESH_TOKEN: "refreshToken",
  CONFIG: "config",
  CREATE_BOOKING: "createBooking",
  ADDRESS_SEARCH: "addressSearch",
  ADDRESS_STREET_NUMBER: "addressNumberSearch",
  FETCH_BOOKINGS: "fetchBookings",
  GET_BOOKING: "getBooking",
  CANCEL_BOOKING: "cancelBooking",
  CALCULATE_PRICE: "calculatePrice",
  GET_RECEIPT_TEXT: "getReceiptText",
  // Served by mock/server.mjs only, until the API gives the car's position (see services/carPosition.ts)
  MOCK_CAR_POSITION: "mockCarPosition"
} as const

export type Endpoint = (typeof Endpoint)[keyof typeof Endpoint]

export default Endpoint
